<template>
  <div class="grid modal-comment__container">
    <div class="grid__col--2 modal-comment__icon-container h-center-align">
      <div class="modal-comment__icon" v-if="author.headshot"><img class="modal-comment__icon-image" :src="author.headshot" /></div>
      <div class="modal-comment--blank modal-comment__icon modal-comment__icon--blank" v-else></div>
    </div>
    <div class="grid__col--10 h-no-padding modal-comment__text-container">
      <div class="modal-comment__author">{{ author.fullName }}</div>
      <div class="modal-comment__datetime">{{ displayDate(comment.created_time, 'MM/DD/YYYY') }}</div>
      <div class="modal-comment__content" v-html="comment.note"></div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'Comment',
    props: ['comment'],
    computed: {
      author() {
        if (this.comment.fuel_user_id) {
          return this.comment.user;
        }
        if (this.comment.contact_id) {
          return this.comment.contact;
        }
        if (this.comment.attendee_id) {
          return this.comment.attendee;
        }
        return false;
      },
      authorFullName() {
        return this.author ? this.author.fullName : '';
      },
      authorHeadshot() {
        return this.author ? this.author.headshot : false;
      },
    },
    methods: {
      displayDate(aDate, format) {
        if (aDate !== null && aDate !== '') {
          return moment(aDate).format(format);
        }
        return aDate;
      },
    },
  };
</script>
